import { patchApiGalaxyServer } from 'services';

export interface UpdateTeamDto {
  teamId: string;
  nicknames: string[];
}

export type UpdateTeamPayload = UpdateTeamDto[];

export interface UpdateTeamResponse {
  affected: number;
}

export const updateTeamApi = ({ params, token, config }: BaseApiParams<UpdateTeamPayload>) => {
  return patchApiGalaxyServer('/lookup/teams', params, config, token);
};
